var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"},[_c('h2',[_vm._v("单位简介")])]),_c('div',{staticClass:"content-con"},[_c('div',{staticClass:"e_richText-1 s_title clearfix response-transition"},[_c('p',[_c('br'),_vm._v("        湖北省残疾人就业服务中心，为省残联直属正处级事业单位，公益一类，事业编制15人。中心内设一室三科，分别是办公室（财务室）、劳动保障科、就业指导科、盲人按摩指导科。 ")])])])])
}]

export { render, staticRenderFns }